import React from "react";
import { StethoscopeIcon, TimerIcon, SearchIcon, ListChecksIcon, WorkflowIcon, BookOpenIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { painPoints } from "../../data/content";
const iconMap = {
  case: StethoscopeIcon,
  time: TimerIcon,
  think: SearchIcon,
  list: ListChecksIcon,
  link: WorkflowIcon,
  book: BookOpenIcon
};
export function PainPoints() {
  return <section className="bg-paper px-5 py-16 sm:py-20" data-id="element-233" data-mp="2hmky4vtoc3z2">
      <div className="mx-auto max-w-6xl" data-id="element-234" data-mp="2ckc4dx8z8xvw">
        <SectionHeading tone="light" title="Does Any of This Sound Familiar?" subtitle="If you recognize yourself in any of these situations, I created OCCLUSION BLUEPRINT™ with you in mind." data-id="element-235" data-mp="2cnhvtj52wbus" />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-236" data-mp="w6lwsginfrhi">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <article key={p.title} className="flex gap-4 rounded-2xl bg-white p-5 shadow-[0_2px_12px_rgba(10,23,41,0.06)] ring-1 ring-slate-200 sm:p-6" data-id="element-237" data-mp="s7wmiwswqq23">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ink-900 text-brand" data-id="element-238" data-mp="1s7y0ru5t660s">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-239" data-mp="1x4oisn16bbou" />
                </span>
                <div data-id="element-240" data-mp="21xhl749667xr">
                  <h3 className="font-display text-[17px] font-extrabold leading-snug text-ink-900" data-id="element-241" data-mp="21ysq57ecplqg">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-242" data-mp="26y5g410ir8x9">{p.text}</p>
                </div>
              </article>;
        })}
        </div>

        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-243" data-mp="2fxaacv51sg3m">
          <h3 className="font-display text-2xl font-black text-ink-900 sm:text-3xl" data-id="element-244" data-mp="2kvu076mric19">The Good News?</h3>
          <p className="mt-3 text-lg font-semibold text-brand-dark" data-id="element-245" data-mp="lj99k4pxtj0w">You don't have to reorganize everything yourself.</p>
          <p className="mt-3 text-base leading-relaxed text-slate-700" data-id="element-246" data-mp="qi2rqag65y7e">
            I created OCCLUSION BLUEPRINT™ to bring these resources together in one practical system. The objective isn't to make complex clinical decisions automatic — it's to help you approach your assessment with a clearer structure, better documentation, and a more organized way of thinking through each case.
          </p>
        </div>

        <div className="mt-10" data-id="element-247" data-mp="nemvfc3ld9x8">
          <CtaButton label="Yes, I Want a Structured Occlusion System" tone="light" data-id="element-248" data-mp="11fh6k2i0xozl" />
        </div>
      </div>
    </section>;
}